import { ActionType } from 'typesafe-actions';
import * as dataExtractionDefinitionsActionCreators from './actions';
import reducer from './reducer';

export default reducer;

export const actions = dataExtractionDefinitionsActionCreators;

export * from './types';
export type DataExtractionDefinitionsActions = ActionType<
  typeof dataExtractionDefinitionsActionCreators
>;
